import { addElementAfter, manageFileInput } from '../modules/forms'


const selectsDOM = document.querySelectorAll('.form-select select')
selectsDOM.forEach(s => addElementAfter(s, '.icon'))

const fileInput = document.querySelector('[type="file"]');
if(fileInput) manageFileInput(fileInput)